<template>
  <div class="">
    <a-upload
      v-model:file-list="fileList"
      :multiple="true"
      @preview="handlePreview"
      :before-upload="beforeUpload"
      :custom-request="customRequest"
      @change="handleUploadChange"
      :disabled="canuseUpload"
    >
      <div>
        <plus-outlined />
        <div class="ant-upload-text">
          {{ props.title ? props.title : "上传附件" }}
        </div>
      </div>
    </a-upload>
  </div>

  <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
    <img alt="example" style="width: 100%" :src="previewImage" />
  </a-modal>
</template>

<script>
import { defineComponent, ref, watch } from "vue";
import { message } from "ant-design-vue";
import { useStore } from "vuex";
import { uploadAttachment } from "@/request/view/repair";
import { Toast } from "@/utils";
import { useRoute } from "vue-router";
import axios from "axios";

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

export default defineComponent({
  props: {
    attachment: String,
    disabled: Boolean,
    title: String,
  },
  setup(props, context) {
    const store = useStore();
    const fileList = ref([]);
    const canuseUpload = ref(false);
    const setFileList = (list) => {
      const time = new Date();
      list.forEach((url) => {
        const name = url.slice(url.lastIndexOf("/") + 1, url.length);
        fileList.value.push({
          uid: time.getTime() + Math.random(5),
          status: "done",
          name,
          url,
        });
      });
    };

    const previewVisible = ref(false);
    const previewImage = ref("");

    const getTxt = (url, name) => {
      axios({
        method: "GET",
        url,
        responseType: "blob",
        headers: {
          "Content-Type": "application/json; application/octet-stream",
          "Cache-Control": "no-cache",
        },
        withCredentials: false,
      }).then((res) => {
        let blob = new Blob([res.data], { type: "application/txt" });
        let reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onload = function (e) {
          let a = document.createElement("a");
          a.download = name;
          a.href = e.target.result;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        };
      });
    };

    const downloadFile = (obj, name, httpUrl) => {
      const url = httpUrl
        ? httpUrl
        : window.URL.createObjectURL(new Blob([obj]));
      if (name.indexOf("txt") !== -1 && httpUrl) {
        getTxt(url, name);
        return;
      }
      const link = document.createElement("a");
      link.style.display = "none";
      link.href = url;
      link.setAttribute("download", name);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };
    const handlePreview = async (file) => {
      if (file.url) {
        downloadFile(file.url, file.name, file.url);
      } else {
        downloadFile(file.originFileObj, file.name);
      }
    };
    const handleCancel = () => {
      previewVisible.value = false;
    };
    // 上传之前的检验
    const beforeUpload = (file) => {
      return true;
    };

    const uploadFile = () => {
      return new Promise((resolve, reject) => {
        const formData = new FormData();
        let needUpload = false;
        fileList.value.forEach((file) => {
          if (file.url) {
            return;
          }
          needUpload = true;
          formData.append("files", file.originFileObj);
        });

        if (!needUpload) {
          let fileUrl = [];
          fileList.value.forEach((item) => {
            fileUrl.push(item.url);
          });
          resolve(fileUrl);
        }
        uploadAttachment(formData)
          .then((res) => {
            if (res.code === 200 && res.message === "成功") {
              const localFile = [];
              fileList.value.forEach((item) => {
                if (item.url) {
                  localFile.push(item.url);
                }
              });
              res.data.push(...localFile);
              resolve(res.data);
            } else {
              reject();
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    };

    const handleUploadChange = (file) => {
      console.log("文件上传", file);
      file.file.status = "done";
    };

    const customRequest = () => {
      console.log("upload");
    };

    watch(
      () => props.attachment,
      (val, oldval) => {
        fileList.value.length = 0;
        if (val) {
          const fileList = JSON.parse(val);
          setFileList(fileList);
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );

    watch(
      () => props.disabled,
      (val) => {
        canuseUpload.value = val;
      },
      {
        immediate: true,
        deep: true,
      }
    );

    return {
      handlePreview,
      fileList,
      previewVisible,
      handleCancel,
      previewImage,
      beforeUpload,
      uploadFile,
      customRequest,
      handleUploadChange,
      setFileList,
      canuseUpload,
      props,
    };
  },
});
</script>

<style lang="less" scoped>
.ant-upload-text {
  padding: 5px 10px;
  border: 1px solid #ccc;
}
</style>
